import jMoment from 'moment-jalaali';
import { FILTER_TYPES } from 'components/FilterPod';

const USER_TYPE = [
  {
    label: 'کاربر حقیقی(پادی)',
    value: '2',
  },
  {
    label: 'کاربر حقوقی(شعب)',
    value: '1',
  }
];
const USER_TYPE_SUPER_ADMIN = [
  {
    label: 'کاربر حقوقی(شعب)',
    value: '1',
  }
];

const USER_TYPE_LIST_NATURAL = [
  {
    label: 'نام کاربری',
    value: 'username',
  },
  {
    label: 'پست الکترونیک',
    value: 'email',
  },
  {
    label: 'تلفن همراه',
    value: 'phone_number',
  },
  {
    label: 'شناسه SSO',
    value: 'id',
  },
  {
    label: 'کد ملی',
    value: 'nationalcode',
  },
];

const USER_TYPE_LIST_LEGAL = [
  {
    label: 'نام کاربری',
    value: 'username',
  },
  {
    label: 'پست الکترونیک',
    value: 'email',
  },
  {
    label: 'شناسه کسب و کار',
    value: 'id',
  },
];

const INPUT_TITLE = {
  username: 'نام کاربری',
  email: 'پست الکترونیک',
  phone_number: 'تلفن همراه',
  id: 'شناسه',
  nationalcode: 'کد ملی'
}

export const customFilter = {
  'username': {
    title: 'نام کاربری',
    label: 'نام کاربری',
    keyName: 'username',
    id: 1,
    value: '',
    filterType: FILTER_TYPES.text,
    filterProps: { dir: 'ltr', englishNumber: true },
    disableDelete: true,
  },
  'email': {
    title: 'پست الکترونیک',
    label: 'پست الکترونیک',
    keyName: 'email',
    id: 2,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: { dir: 'ltr', englishNumber: true },
    disableDelete: true,
  },

  'id': {
    title: 'شناسه',
    label: 'شناسه',
    keyName: 'id',
    id: 3,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: { dir: 'ltr', englishNumber: true },
    disableDelete: true,
  },

  'phone_number': {
    title: 'تلفن همراه',
    label: 'تلفن همراه',
    keyName: 'phone_number',
    id: 6,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: { dir: 'ltr', englishNumber: true },
    disableDelete: true,
  },

  'nationalcode': {
    title: 'کد ملی',
    label: 'کد ملی',
    keyName: 'nationalcode',
    id: 8,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: { dir: 'ltr', englishNumber: true },
    disableDelete: true,
  }
};



export const legalUser = [
  {
    title: 'نوع اطلاعات کاربر',
    label: 'نوع اطلاعات کاربر',
    keyName: 'userTypeList',
    id: 1354,
    value: 'username',
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: USER_TYPE_LIST_LEGAL,
    },
    disableDelete: true,
  },
];

export const naturalUser = [

  {
    title: 'نوع اطلاعات کاربر',
    label: 'نوع اطلاعات کاربر',
    keyName: 'userTypeList',
    id: 1353,
    value: 'username',
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: USER_TYPE_LIST_NATURAL,
    },
    disableDelete: true,
  },
]
const filters = (isSuperAdmin = false) => [
  {
    title: 'نوع کاربر را انتخاب نمایید',
    label: 'نوع کاربر را انتخاب نمایید:',
    keyName: 'userType',
    id: 1352,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: isSuperAdmin ? USER_TYPE_SUPER_ADMIN : USER_TYPE,
    },
    disableDelete: true,
  },
];

export default filters;
